import { useQuery } from '@tanstack/react-query';
import { activityPointQueryKey } from 'queries/activityPoint/queryKey';
import { AttendanceCheckApi } from 'api/ApiHelper';

export const useGetAttendanceCheckParticipateQuery = (attendanceCheckMonthId: number) =>
  useQuery({
    queryKey: activityPointQueryKey.attendanceCheckParticipate(attendanceCheckMonthId),
    queryFn: () => AttendanceCheckApi.getParticipate(attendanceCheckMonthId),
    enabled: attendanceCheckMonthId > 0,
  });
